import { makeStyles, Typography } from '@material-ui/core';
import React, { useContext } from 'react';
import { SubmitHandler } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import ArrowBackIcon from '@material-ui/icons/ArrowBackOutlined';
import { Step1, Step2, Step3 } from 'components/Forms/CharacterizationForm';
import MultiStepForm from 'components/Forms/MultiStepForm';
import { notify } from 'components/Notifier';
import { AppContext } from 'context';
import { Routes } from 'routes';
import { postCharacterization } from 'services/apiOperations';
import { CharacterizationForm, Client, Stream } from 'types';
import { formatCharacterizationBeforePost } from 'utils/normalizer';
import { goBack } from 'utils/history';

const useStyles = makeStyles({
  headerTitle: {
    marginBottom: '2rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignContent: 'center',
  },
  title: {
    margin: 0,
  },
});

export type CharacterizationFormContext = {
  client?: Client;
  stream?: Stream;
  isEditing?: boolean;
};

const CharacterizationCreate: React.FC = () => {
  const context = useContext(AppContext);
  const history = useHistory();
  const classes = useStyles();
  const { t } = useTranslation();

  const onSubmit: SubmitHandler<CharacterizationForm> = async (characterization: CharacterizationForm) => {
    const sortingCenterId = context.getSortingCenter?.()?.['@id'] ?? null;

    if (null === sortingCenterId) {
      notify({
        message: t('characterizationCreate.creation.error'),
        severity: 'error',
      });
      return;
    }
    let formattedCharacterization = formatCharacterizationBeforePost(characterization, sortingCenterId);
    return postCharacterization(formattedCharacterization)
      .then(() => {
        notify({
          message: t('characterizationCreate.creation.success'),
          severity: 'success',
        });
        goBack(Routes.Characterizations, history);
      })
      .catch(() => {
        notify({
          message: t('errorGeneric'),
          severity: 'error',
        });
      });
  };
  const steps = [
    { label: t('characterizationForm.steps.step1'), component: Step1, requiredFieldsLegend: true },
    { label: t('characterizationForm.steps.step2'), component: Step2 },
    { label: t('characterizationForm.steps.step3'), component: Step3 },
  ];
  const initialData = {
    samplingDate: null,
    analyseDate: null,
    client: '',
    stream: '',
    comment: '',
    characterizationMaterials: [],
  };
  return (
    <>
      <div className={classes.headerTitle}>
        <Typography variant="h1" className={classes.title}>
          {t('characterizationForm.create.title')}
        </Typography>
      </div>
      <MultiStepForm
        formName="characterizationForm"
        backRoute="/characterizations"
        backIcon={<ArrowBackIcon />}
        onSubmit={onSubmit}
        steps={steps}
        initialData={initialData}
        initialContext={{ isEditing: false }}
      />
    </>
  );
};
export default CharacterizationCreate;
